import type { ReactNode } from 'react';
import { RouterProvider as RACRouterProvider } from 'react-aria-components';
import type { Href, RouterOptions } from '../../components/types.js';

export interface RouterProviderProps {
  /** The component tree that will use client-side router navigation (usually the entire application). */
  children: ReactNode;
  /** A function received from your router for performing client-side navigation programmatically. */
  navigate: (path: Href, routerOptions?: RouterOptions) => void;
  /** An optional prop that converts a router-specific `href` to a native HTML `href`. */
  useHref?: (href: Href) => string;
}

/**
 * Allows Cimpress UI components to perform navigation using a client-side router.
 *
 * See [client-side routing guide](https://ui.cimpress.io/dev-guides/client-side-routing/).
 */
export function RouterProvider({ children, navigate, useHref }: RouterProviderProps) {
  return (
    <RACRouterProvider navigate={navigate} useHref={useHref}>
      {children}
    </RACRouterProvider>
  );
}

RouterProvider.displayName = 'RouterProvider';
